export interface ImportReportRecipient {
  id?: number;
  email: string;
  categories: string[];
  createdAt?: string;
  updatedAt?: string;
}

export type ImportReportCategories = { [category: string]: string[] };

export const IMPORT_REPORT_CATEGORY_LABELS: { [category: string]: string } = {
  ethos: "Ethos Products",
  pbs_vehicles: "PBS Vehicles",
  pbs_users: "PBS Users",
  toyota: "Toyota Incentives & Residuals"
};
